(() => {
  'use strict';
  document.addEventListener('wheel', event => {
    if (event.ctrlKey || !window.matchMedia('(min-width: 1024px)').matches || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
    const nav = event.target.closest?.('media-gallery[data-layout="layout-6"] .nav-swiper-container');
    const slider = nav?.swiper;
    if (!slider || slider.destroyed || !slider.isVertical() || slider.isLocked || !event.deltaY) return;
    const scale = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? nav.clientHeight : 1;
    const previous = slider.translate;
    const next = Math.max(slider.maxTranslate(), Math.min(slider.minTranslate(), previous - event.deltaY * scale));
    if (Math.abs(next - previous) < 0.5) return;
    event.preventDefault();
    slider.setTransition(0);
    slider.setTranslate(next);
    slider.updateProgress(next);
    slider.updateActiveIndex();
    slider.updateSlidesClasses();
  }, { passive: false });
})();
